import React from 'react';

const LOGO_SRC = `${process.env.PUBLIC_URL || ''}/images/auralux-logo.png`;
export const HERO_MARK_SRC = `${process.env.PUBLIC_URL || ''}/images/auralux-hero-mark.png`;
const MARK_SRC = HERO_MARK_SRC;
const ICON_SRC = `${process.env.PUBLIC_URL || ''}/images/auralux-icon.png`;

/**
 * @param {'full' | 'mark' | 'icon'} variant — full wordmark, transparent circular mark, or favicon asset
 * @param {'hero' | 'nav' | 'footer' | 'inline'} placement
 */
export default function BrandLogo({ variant = 'full', placement = 'inline', className = '', alt }) {
  const src =
    variant === 'full' ? LOGO_SRC : variant === 'mark' ? MARK_SRC : ICON_SRC;
  const defaultAlt =
    alt ||
    (variant === 'full'
      ? 'Auralux — Harmony Through Precision and Sustainability'
      : 'Auralux');

  const placementClass =
    placement === 'hero' && variant === 'mark'
      ? 'brand-logo brand-logo--hero-mark'
      : placement === 'hero'
      ? 'brand-logo brand-logo--hero'
      : placement === 'nav'
        ? 'brand-logo brand-logo--nav'
        : placement === 'footer'
          ? 'brand-logo brand-logo--footer'
          : 'brand-logo';

  return (
    <img
      src={src}
      srcSet={variant === 'mark' ? `${src} 1x, ${src} 2x` : undefined}
      alt={defaultAlt}
      className={[placementClass, className].filter(Boolean).join(' ')}
      width={variant === 'mark' ? 1831 : variant === 'icon' ? 64 : undefined}
      height={variant === 'mark' ? 2048 : variant === 'icon' ? 64 : undefined}
      decoding="async"
      fetchPriority={placement === 'hero' && variant === 'mark' ? 'high' : undefined}
    />
  );
}
